/**
 * SmsTemplatesAdmin.tsx — Admin > Forms & Templates > SMS Templates: the
 * corporate dashboard's page for the signed-in account, as a drag-and-drop
 * board (see components/admin/MessageTemplateBoard).
 */
import { MessageTemplateBoard } from '@/components/admin/MessageTemplateBoard';

export function SmsTemplatesAdmin() {
  return <MessageTemplateBoard kind="sms" />;
}
